import { createContext, useContext, useMemo } from 'react';
import { Theme, useMediaQuery } from '@mui/material';

export { useMediaQuery };

const ForceMobileContext = createContext(false);
export const ForceMobileProvider = ForceMobileContext.Provider;

interface IConfig {
	enforceMobile?: boolean;
	enforceAboveMobile?: boolean;
}

export const useBreakpoints = (config?: IConfig) => {
	const { enforceMobile, enforceAboveMobile } = config || ({} as IConfig);
	const forceMobile = useContext(ForceMobileContext);

	const isMobile = useMediaQuery((t: Theme) => t.breakpoints.only('mobile'));
	const isAboveMobile = useMediaQuery((t: Theme) =>
		t.breakpoints.up('tabletP')
	);

	return useMemo(() => {
		const result = {
			isMobile: false,
			isAboveMobile: false,
		};

		if (forceMobile || enforceMobile) {
			return { ...result, isMobile: true };
		} else if (enforceAboveMobile) {
			return { ...result, isAboveMobile: true };
		} else {
			return { isMobile, isAboveMobile };
		}
	}, [enforceAboveMobile, enforceMobile, forceMobile, isAboveMobile, isMobile]);
};
